import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import TestApp from './app/TestApp';
import './styles/global.css';

const isTestMode = !window.Twitch?.ext;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {isTestMode ? <TestApp /> : <App />}
  </React.StrictMode>
);
